import { Alert, Button, Modal, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { ACTIONS } from "../redux/actions";
import alert from "../utils/alert";
import { CloseCircleIcon, CloseIcon, FileIcon, GoBackIcon, PlusCircleIcon } from './icons';
import { saveUserProfile } from "../utils/profileService";
import { useCallback, useEffect, useState } from "react";
import AzureBlob from "../utils/azureblob";
import AppEditor from "../editor";
import { JobExperienceData, Skill } from "../types";
import routes from "../utils/routes";
import request from "../utils/request";
import { useNavigate } from "react-router-dom";
import { ProfileScore } from "./profileScore";




//TODO: remove this modal and use only one modal
export default function AppModal() {
    const dispatch = useDispatch();
    const props = useSelector((state: any) => state.appReducer.openModal);
    const { element = '', title = '', backdrop = 'static', save, noHide, message, noHideMsg, ...rest } = props || {};
    return (
        <Modal
            onHide={() => {
                if (noHide) {
                    alert({
                        icon: "warning",
                        text: noHideMsg
                    })
                    return;
                }
                dispatch({
                    type: ACTIONS.OPENMODAL,
                    openModal: {
                        element: null
                    }
                })
            }}
            backdrop={backdrop}
            keyboard={false}
            show={element}
            {...rest}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {message ?
                    <div>
                        <Alert variant="danger" onClose={() => dispatch({
                            type: ACTIONS.OPENMODAL,
                            openModal: {
                                ...props,
                                message: ''
                            }
                        })} dismissible>
                            {message || "Error"}
                        </Alert>
                    </div>
                    : null}
                {element}
            </Modal.Body>
            <Modal.Footer>
                <div className={`d-flex w-100 justify-content-between `}>
                    {
                        save && !save?.hide && <Button onClick={() => save.onClick(props)} className="bg-purple">
                            {save.title}
                        </Button>
                    }
                    {
                        save?.otherActions && save.otherActions
                    }
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export function AppModalMod({ children, closeModal, OtherActions, onClickTitle = 'Save', onClick, backdrop = "static", show = false, title = '', message, setMessage, ...rest }: any) {
    return (
        <Modal
            onHide={closeModal}
            backdrop={backdrop}
            keyboard={false}
            show={show}
            {...rest}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter" className="modal-title-custom">
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {message ?
                    <div>
                        <Alert variant="danger" onClose={() => setMessage('')} dismissible>
                            {message || "Error"}
                        </Alert>
                    </div>
                    : null}
                {children}
            </Modal.Body>
            <Modal.Footer>
                <div className={`d-flex w-100 justify-content-between `}>
                    {
                        onClick ? <Button onClick={onClick} className="bg-purple">
                            {onClickTitle}
                        </Button> : null
                    }
                    {
                        OtherActions && OtherActions
                    }
                </div>
            </Modal.Footer>
        </Modal>
    )
}
//NEW JOB MODALS

const dateOptions = () => {
    const currentYear = new Date().getFullYear();
    const startYear = 1900;
    const options = [{ label: "Select Year", value: "" }];

    for (let year = currentYear; year >= startYear; year--) {
        options.push({ label: String(year), value: String(year) });
    }

    return options;
};

export function AppModalFun({ show, onHide, title, children, onSave, OtherActions, profileProgress, onClickTitle = 'Save', onClick, ...rest }: any) {
    if (!show) {
        return null;
    }
    return (
        <Modal show={show} onHide={onHide} size="lg" centered  {...rest}>
            <Modal.Header >
                <GoBackIcon onClick={onHide} className="back-icon" />
                <Modal.Title className=" modal-title-custom" >{title}</Modal.Title>
                <div className="align-items-center " style={{ marginLeft: '20px' }}>
                    <ProfileScore score={profileProgress} />
                </div>
                <Button onClick={onSave} className="submit-button">
                    Submit
                </Button>
                <CloseCircleIcon onClick={onHide} className="modal-close-icon" />
            </Modal.Header>
            <Modal.Body>{children}</Modal.Body>
            <Modal.Footer>
                {/* {footerContent} */}
                <div className={`d-flex w-100 justify-content-between `}>
                    {
                        onClick ? <Button onClick={onClick} className="bg-purple">
                            {onClickTitle}
                        </Button> : null
                    }
                    {
                        OtherActions && OtherActions
                    }
                </div>
            </Modal.Footer>
        </Modal>
    );
}


export function CustomProfileModal({
    show,
    onHide,
    title,
    onSave,
    profileProgress,
    onNext,

    isLastStep,
    isSetupFlow = false,
    modalMode,
    setupStep, saveData, onBack,
    userData,
    updateData,
    uploadFile,
    file,
    jobExperience,
    educationData,
    handleNextStep,
    competencies,
    validateJobExperience,
    validateEducationData,
    handleSave,
    updateJobExperience,
    updateEducationData,
    updateCompetencies,
    contactInformation,
    updateContactInformation,
    validateContactInformation,
    isValid,
    data,
    setShowModal,
    children,
    ...rest
}: any) {

    const [uploadStatus, setUploadStatus] = useState('idle');
    const [uploadProgress, setUploadProgress] = useState(0);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    const modalTitle = (setupStep === 7 || setupStep === 8) ? "Complete Profile" : title;

    const buttonText = (() => {
        if (modalMode === 'setup') {
            if (setupStep === 4) {
                if (uploadStatus === 'uploading') {
                    return 'Uploading...';
                } else if (uploadStatus === 'uploaded') {
                    return 'Successful, proceed';
                } else {
                    return 'Upload CV';
                }
            } else if (setupStep === 5 && uploadStatus === 'uploaded') {
                return 'Save and Continue';
            } else if (setupStep >= 5) {
                return 'Save and Continue';
            } else if (!isLastStep && setupStep <= 8) {
                return 'Save and Continue';
            }
        }
        return 'Continue';
    })();


    const goBack = () => {
        if (modalMode === 'setup') {

            navigate("/my-profile")
        } else {

            onHide();
        }
    }

    const handleContinue = async () => {

        if (modalMode === 'edit') {
            onSave(data)

        } else if (modalMode === 'setup') {
            switch (setupStep) {
                case 1:

                    onNext()
                    break;
                case 2:

                    if (!userData.firstName || !userData.lastName) {
                        setErrorMessage("Please fill out all required fields.");

                    } else {
                        await saveData(userData, 'personalInfo');

                        setErrorMessage('');
                        onNext();
                    }
                    break;

                case 3:

                    if (!userData.gender || !userData.dateOfBirth) {
                        setErrorMessage("Please fill out all required fields.");

                    } else {
                        await saveData(userData, 'biodata');
                        setErrorMessage('');
                        onNext();
                    }
                    break;
                case 4:
                    if (!file) {
                        setErrorMessage('Please select a file.');
                    } else if (uploadStatus !== 'uploaded' && uploadStatus !== 'uploading') {
                        setUploadStatus('uploading');
                        const uploadResult = await uploadFile(file);
                        if (uploadResult && uploadResult.success) {
                            setUploadStatus('uploaded');
                            setUploadProgress(100);
                            setErrorMessage('');
                            await saveData({ resumeUrl: uploadResult.url }, 'resume');
                            onNext();
                        } else {
                            setUploadStatus('error');
                            setErrorMessage('Upload failed. Please try again.');
                        }
                    }
                    break;

                case 5:
                    const jobValidationResult = validateJobExperience(jobExperience);
                    if (jobValidationResult.isValid) {
                        await saveData(jobExperience, 'jobExperience');
                        setErrorMessage('');
                        onNext();
                    } else {
                        setErrorMessage(jobValidationResult.errors.join(" "));
                    }
                    break;

                case 6:
                    if (validateEducationData(educationData)) {
                        await saveData(educationData, 'education');
                        onNext();
                    } else {
                        console.log("Job experience data is invalid.");
                    }
                    break;

                case 7:
                    if (competencies && competencies.length > 0) {
                        setErrorMessage("");
                        await saveData(competencies, 'competency');
                        onNext();
                    } else {
                        console.log("No competencies to save.");
                        setErrorMessage("Please select competency");
                    }
                    break;

                case 8:
                    if (validateContactInformation(contactInformation)) {
                        console.log("this is contac info", contactInformation)
                        const addressData = {
                            country: contactInformation.country,
                            location: contactInformation.state,
                            city: contactInformation.city,
                            address: contactInformation.streetAddress,
                        };
                        await saveData(addressData, 'address');

                        setShowModal(false);
                    } else {
                        console.log("Contact information is invalid.");
                        setErrorMessage("Contact information is invalid.");
                    }
                    break;

                default:

                    onSave();
                    break;
            }
        }
    };

    const renderHeaderContent = () => {
        if (setupStep === 1) {
            return (
                <div className=" setup-first-div">
                    <Modal.Title className="modal-title-custom">{title}</Modal.Title>
                    <div className=" align-items-center">
                        <div className="align-items-center " style={{ marginLeft: '20px' }}>
                            <ProfileScore score={profileProgress} />
                        </div>

                    </div>
                </div>
            );
        } else {
            return (
                <>
                    <GoBackIcon onClick={goBack} className="back-icon" />
                    <Modal.Title className="modal-title-custom">{modalTitle}</Modal.Title>
                    <div className="align-items-center " style={{ marginLeft: '20px' }}>
                        <ProfileScore score={profileProgress} />
                    </div>

                    <div className="modal-btn-div">
                        {(setupStep === 7 || setupStep === 8) && (
                            <Button onClick={onHide} className="save-exit-button">
                                Save and Exit
                            </Button>
                        )}

                        {setupStep !== 9 && (
                            <Button onClick={() => handleContinue()} disabled={uploadStatus === 'uploading'} className="submit-button">
                                {buttonText}
                            </Button>

                        )}
                    </div>
                </>
            );
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header>
                {renderHeaderContent()}
                <CloseCircleIcon onClick={onHide} className="modal-close-icon" />
            </Modal.Header>
            {errorMessage && (
                <div className="error-message-div" style={{ color: 'red', marginTop: '10px' }}>
                    {errorMessage}
                </div>
            )}
            <Modal.Body>{children}</Modal.Body>

        </Modal>
    );
}



//ACCOUNT SETUP MODALSs
export const IntroModalContent = ({ onNext }: any) => (

    <div className="setup-div">
        <h2 className="about-me-header">Setup an account in few easy steps.</h2>
        <p className="about-me-description">
            Thank you for signing up we need more information from you we will be taking some personal and professional and academic information from you..
        </p>
        <div className="btn-setup-div">
            <Button className="setup-get-started-btn" onClick={onNext} >Get Started</Button>

        </div>
    </div>

);

export const PersonalInfoModalContent = ({ onNext, updateData }: any) => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    return (
        <div className="setup-div">
            <h2 className="about-me-header">Personal Information</h2>
            <p className="about-me-description">
                Please provide the following information to help you build a better profile.
            </p>
            <div className="setup-profile-name ">
                <div className="setup-firstname">
                    <label htmlFor="firstname" className="label-address mb-2">First Name <span className="text-danger">*</span></label>
                    <input type="text"
                        className="input-setup"
                        value={firstName}
                        onChange={(e) => {
                            setFirstName(e.target.value);
                            updateData({ firstName: e.target.value });
                        }}
                    />

                </div>
                <div className="lastname">
                    <label htmlFor="firstname" className="label-address">Last Name <span className="text-danger">*</span></label>
                    <input
                        type="text"
                        className="input-setup"
                        value={lastName}
                        onChange={(e) => {
                            setLastName(e.target.value);
                            updateData({ lastName: e.target.value });
                        }}
                    />

                </div>
            </div>

        </div>
    );

}

export const BiodataModalContent = ({ onNext, updateData }: any) => {
    const [gender, setGender] = useState('');
    const [dateOfBirth, setDateOfBirth] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleGenderChange = (e: any) => {
        setGender(e.target.value);
        updateData({ gender: e.target.value });
    };

    const validateDateOfBirth = (date: any) => {
        const selectedDate = new Date(date);
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        return selectedDate <= currentDate;
    };

    const handleDateOfBirthChange = (e: any) => {
        const newDate = e.target.value;
        if (validateDateOfBirth(newDate)) {
            setDateOfBirth(newDate);
            updateData({ dateOfBirth: newDate });

            setErrorMessage('');
        } else {
            setDateOfBirth('');
            updateData({ dateOfBirth: '' });
            setErrorMessage("Date of birth cannot be in the future!");

        }

    };


    return (
        <div className="setup-div">
            <h2 className="about-me-header">Biodata Information</h2>
            <p className="about-me-description">
                This information is required to further help you build a profile that makes you eligible for recruitment.
            </p>
            <div className="setup-profile-name ">
                <div className="setup-firstname">
                    <label htmlFor="gender" className="label-address mb-2">Gender <span className="text-danger">*</span></label>
                    <select
                        name="gender"
                        className="input-setup"
                        value={gender}
                        onChange={handleGenderChange}
                    >
                        <option value="">Provide Your Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>

                    </select>
                </div>
                <div className="lastname">

                    <label htmlFor="dateOfBirth" className="label-address">Date of Birth<span className="text-danger">*</span></label>
                    {errorMessage && <div className="alert" style={{ color: 'red' }}>{errorMessage}</div>}
                    <input
                        type="date"
                        name="dateOfBirth"
                        placeholder="DD/MM/YY"
                        className="input-setup"
                        value={dateOfBirth}
                        onChange={handleDateOfBirthChange}
                    />

                </div>
            </div>
        </div>
    );
};


export const ResumeContentModal = ({ setFile, file, uploadFile, errorMessage, setErrorMessage, }: any) => {
    const handleDrop = useCallback(async (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer.files && event.dataTransfer.files[0]) {
            const droppedFile = event.dataTransfer.files[0];

            setFile(droppedFile);
            await uploadFile(droppedFile);

            setErrorMessage('');
        }
    }, [setFile]);

    const handleFileSelect = useCallback(async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            const selectedFile = event.target.files[0];
            setFile(selectedFile);
            await uploadFile(selectedFile);

            setErrorMessage('');
        }
    }, [setFile]);

    const handleDeselectFile = () => {
        setFile(null);
    };

    return (
        <div className="setup-div">
            <h2 className="about-me-header">Upload Cv</h2>
            <p className="about-me-description">
                Upload your CV to quickly apply for jobs on the Go. This is a one-time thing.
            </p>

            <div className="upload-and-label">
                <label htmlFor="file-upload" className="upload-cv mb-2">Upload</label>
                <input id="file-upload" type="file" onChange={handleFileSelect} style={{ display: 'none' }} />

                <div className={file ? "cv-div file-selected" : "cv-div"} onDrop={handleDrop} onDragOver={(event) => event.preventDefault()}>
                    {file ? (
                        <div className="file-info-div">
                            <span className="file-name">{file.name}</span>
                            <button className="deselect-file-btn" onClick={handleDeselectFile}>
                                <CloseCircleIcon />
                            </button>
                        </div>
                    ) : (
                        <span className="placeholder-text">Drag and drop or browse files</span>
                    )}
                </div>
            </div>
        </div>
    );
};


export const JobExperienceModalContent = ({ clearWorkExperience, jobExperience, updateJobExperience }: any) => {
    const [localExperience, setLocalExperience] = useState(jobExperience);
    const yearOptions = dateOptions();

    const handleChange = (event: any) => {
        const { name, value } = event.target;
        const updatedExperience = { ...localExperience, [name]: value };

        setLocalExperience(updatedExperience);
        updateJobExperience(updatedExperience);
    };

    const handleEditorChange = ({ html, text }: any) => {
        const description = { formatted: html, unformatted: text };
        const updatedExperience = { ...localExperience, description: description };

        setLocalExperience(updatedExperience);
        updateJobExperience(updatedExperience);
    };

    return (
        <div className="setup-div">
            <h2 className="about-me-header">Add Job Experience</h2>
            <p className="about-me-description">
                Providing a job experience helps employers to understand that you are capable of doing the job. Use the form below to add your past job experiences.
            </p>
            <form className="setup-work-modal"  >
                {/* Job Title and Company */}
                <div className="form-group d-flex work-setup-modal-2">
                    <div >
                        <label htmlFor="title" className="label-style">
                            Job Title <span className="text-danger">*</span>
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="title"
                            placeholder="Job Title"
                            name="title"
                            required
                            value={localExperience.title}
                            onChange={handleChange}

                        />
                    </div>
                    <div>
                        <label htmlFor="company" className="label-style mb-2">
                            Company <span className="text-danger">*</span>
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="company"
                            placeholder="Company"
                            name="company"
                            value={localExperience.company}
                            onChange={handleChange}
                            required />
                    </div>
                </div>

                {/* Start Year and End Year */}
                <div className="form-group d-flex mt-2 work-setup-modal-2">
                    <div className="date-year-div" >
                        <label htmlFor="startYear" className="label-style">
                            Start Year <span className="text-danger">*</span>
                        </label>

                        <select
                            className="form-control select-year"
                            name="startYear"
                            value={localExperience.startYear}
                            onChange={handleChange}
                            id="startYear"
                            required
                        >
                            {yearOptions.map((option, index) => (
                                <option key={index} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="date-year-div">
                        <label htmlFor="endYear" className="label-style">
                            End Year <span className="text-danger">*</span>
                        </label>

                        <select
                            className="form-control select-year"
                            id="endYear"
                            name="endYear"
                            required
                            value={localExperience.endYear}
                            onChange={handleChange}
                        >
                            {yearOptions.map((option, index) => (
                                <option key={index} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>

                    </div>
                </div>

                {/* Job Description */}
                <div className="form-group">
                    <label htmlFor="description" className="label-address mt-4 mr-4 mb-1">
                        Add Job Description <span className="text-danger">*</span>
                    </label>
                    {/* Editor for job description */}
                    <div className="work-experience-editor editor-container">
                        <AppEditor
                            value={jobExperience.description.formatted}
                            useDraft={true}
                            onChange={handleEditorChange}
                        />
                    </div>

                    {/* <button onClick={clearWorkExperience}>Clear Work Experience</button> */}


                </div>
            </form>


        </div>
    );
}

export const EducationInfoModal = ({ onNext, updateEducationData, }: any) => {
    const combos = useSelector((state: any) => state.appReducer.combos);
    const [institution, setInstitution] = useState('');
    const [degree, setDegree] = useState('');
    const [degreeType, setDegreeType] = useState('');
    const degreeTypeOptions = [
        {
            value: "",
            label: ""
        },
        {
            value: "Certificate",
            label: "Certificate"
        },
        {
            value: "Diploma",
            label: "Diploma"
        },
        {
            value: "Associate degree",
            label: "Associate degree"
        },
        {
            value: "Bachelor's degree",
            label: "Bachelor's degree"
        },
        {
            value: "Post-Baccalaureate Certificate",
            label: "Post-Baccalaureate Certificate"
        },
        {
            value: "Master's/Graduate degree",
            label: "Master's/Graduate degree"
        },
        {
            value: "Post-Master's Certificate",
            label: "Post-Master's Certificate"
        },
        {
            value: "Doctoral degree",
            label: "Doctoral degree"
        },
        {
            value: "First Professional",
            label: "First Professional"
        }
    ];

    // Update individual fields
    const handleInstitutionChange = (event: any) => {
        setInstitution(event.target.value);
    };

    const handleDegreeChange = (event: any) => {
        setDegree(event.target.value);
    };

    const handleDegreeTypeChange = (event: any) => {
        setDegreeType(event.target.value);
    };

    useEffect(() => {
        updateEducationData({ institution, degree, degreeType });
    }, [institution, degree, degreeType, updateEducationData]);

    return (
        <div className="setup-div">
            <h2 className="about-me-header">Add Educational Information</h2>
            <p className="about-me-description">
                Providing your educational history helps employers to understand your qualifications.
            </p>
            <div className="row educational-form-div">
                {/* Institution select input */}
                <div className="form-group mb-2">
                    <label htmlFor="institution" className="label-style mb-2">Name of Institution<span className="text-danger">*</span></label>
                    <select
                        className="form-control"
                        id="institution"
                        name="institution"
                        value={institution}
                        onChange={handleInstitutionChange}
                        required>
                        <option value="">Select Institution</option>
                        {combos.universities.map((uni: string, index: number) => (
                            <option key={index} value={uni}>{uni}</option>
                        ))}
                    </select>
                </div>

                {/* Degree select input */}
                <div className="form-group mb-2">
                    <label htmlFor="degree" className="label-style">Course of Study<span className="text-danger">*</span></label>
                    <select
                        className="form-control"
                        id="degree"
                        name="degree"
                        value={degree}
                        onChange={handleDegreeChange}
                        required>
                        <option value="">Select Course</option>
                        {combos.courses.map((course: string, index: number) => (
                            <option key={index} value={course}>{course}</option>
                        ))}
                    </select>
                </div>

                {/* DegreeType select input */}
                <div className="form-group mb-2">
                    <label htmlFor="degreeType" className="label-style">Degree Type<span className="text-danger">*</span></label>
                    <select
                        className="form-control"
                        id="degreeType"
                        name="degreeType"
                        value={degreeType}
                        onChange={handleDegreeTypeChange}
                        required>
                        <option value="">Select Degree Type</option>
                        {degreeTypeOptions.map((option: any, index: number) => (
                            <option key={index} value={option.value}>{option.label}</option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
};


export const CompetencySetupModal = ({ updateCompetencies, setErrorMessage, competencies }: any) => {
    const [skills, setSkills] = useState<Skill[]>([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [selectedSkill, setSelectedSkill] = useState('');
    const [selectedRating, setSelectedRating] = useState(1);
    const [addedCompetencies, setAddedCompetencies] = useState<{ skill: string; rating: number; }[]>([]);
    const fetchSkills = async () => {
        try {
            const result = await request({
                url: routes.skills,
                method: "GET",
                dispatch,
                navigate
            });

            if (result?.statusCode === 200) {
                const skillsData = result.payload.data.map((skill: { _id: any; name: any; }) => ({
                    id: skill._id,
                    name: skill.name
                }));

                setSkills(skillsData);
            }
        } catch (error) {
            console.error('Failed to fetch skills:', error);
        }
    };

    useEffect(() => {
        fetchSkills();
    }, []);


    const handleSkillInputChange = (e: any) => {
        setSelectedSkill(e.target.value);
    };

    const isValidCompetency = () => {
        if (!selectedSkill || !selectedRating) {
            setErrorMessage('Please select a skill and a rating.');
            return false;
        }
        if (selectedRating < 1 || selectedRating > 5) {
            setErrorMessage('Rating must be between 1 and 5.');
            return false;
        }
        setErrorMessage('');
        return true;
    };

    const handleAddCompetency = () => {
        if (isValidCompetency()) {
            const newCompetency = { skill: selectedSkill, rating: selectedRating };

            const updatedCompetencies = [...addedCompetencies, newCompetency];
            setAddedCompetencies(updatedCompetencies);
            updateCompetencies(updatedCompetencies);
            setSelectedSkill('');
            setSelectedRating(1);
        }
    };

    const handleRemoveSkill = (indexToRemove: any) => {
        const updatedCompetencies = addedCompetencies.filter((_, index) => index !== indexToRemove);

        setAddedCompetencies(updatedCompetencies);
        updateCompetencies(updatedCompetencies);

    };

    return (
        <>
            <div className="p-2"  >
                <div>
                    <p className="about-me-header">Add Competencies</p>
                    <p className="about-me-description">
                        Your competencies help you standout in the job market. Ensure to add competencies and as much skills as you can to help you land your desired job.
                    </p>
                </div>
                <div className=" skill-form-div-setup">
                    <div>
                        <label className="label-competency">Add Competencies <span className="text-danger">*</span></label>
                        <input
                            list="skills-list"
                            value={selectedSkill}
                            onChange={handleSkillInputChange}
                            className="input-competency"
                            placeholder="Click or Start typing to find a competency "
                        />
                        <datalist id="skills-list">
                            {skills.map((skill, index) => (
                                <option key={index} value={skill.name} />
                            ))}
                        </datalist>

                    </div>
                    <div>
                        <label className="label-competency">Rating</label>
                        <select className="select-competency" value={selectedRating} onChange={(e) => setSelectedRating(Number(e.target.value))}>
                            {[1, 2, 3, 4, 5].map(rating => (
                                <option key={rating} value={rating}>{rating}</option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <Button className="addCompButton" onClick={handleAddCompetency}>
                            <PlusCircleIcon className="button-icon" />
                            Add New
                        </Button>

                    </div>

                </div>
                <div className=" skill-div ">
                    {addedCompetencies.map((comp, index) => (
                        <div className="skill-display-div" key={index}>
                            {comp.skill} - {comp.rating}
                            <CloseIcon className="clickable close-icon" onClick={() => handleRemoveSkill(index)} />
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export const ContactInformation = ({
    updateContactInformation,
    setErrorMessage,
    contactInformation,
    onNext
}: {
    updateContactInformation: (info: any) => void;
    setErrorMessage: (message: string) => void;
    contactInformation: {
        country: string;
        state: string;
        city: string;
        streetAddress: string;
    };
    onNext: () => void;

}): JSX.Element => {
    const { countries } = useSelector((state: any) => state.appReducer.combos);
    const [localContactInfo, setLocalContactInfo] = useState(contactInformation);
    const [states, setStates] = useState<any>([]);
    const [cities, setCities] = useState<any>([]);
    const [stateLoading, setStateLoading] = useState(false);
    const [cityLoading, setCityLoading] = useState(false)
    const dispatch = useDispatch();
    const [token, setToken] = useState<string>('');

    const APITOKEN = "qIxcpJegCJDYKLT1z3j3o1kwOvK1Qt46yV_7U5GQsyIrz_yAxhhdQLGOYPp0hbwdqZk"
    const [errors, setErrors] = useState({
        country: '',
        state: '',
        city: '',
        streetAddress: '',
    });
    const getToken = async () => {
        const token = await request({
            url: `${routes.locationAPI}/getaccesstoken`,
            options: {
                headers: {
                    accept: "application/json",
                    "api-token": APITOKEN,
                    "user-email": "snduaguibe@atb.tech"
                }
            },
            method: "GET",
            dispatch,
            useBaseUrl: false,
            useLoader: false
        })
        setToken(token.auth_token);
        return token.auth_token;
    }

    const callAPI = async (path: string, tokens?: string) => {
        if (!tokens && !token) {
            tokens = await getToken();
        }
        return [await request({
            url: `${routes.locationAPI}${path}`,
            options: {
                headers: {
                    authorization: `Bearer ${tokens || token}`,
                }
            },
            method: "GET",
            dispatch,
            useBaseUrl: false,
            useLoader: false
        }), tokens]
    }
    const fetchEverything = async (selectedCountry: string, selectedState?: string) => {
        if (!selectedCountry) return;

        let tokens;

        setStateLoading(true);
        const [fetchedStates, auth] = await callAPI(`/states/${selectedCountry}`);
        tokens = auth;
        setStates(fetchedStates);
        setStateLoading(false);

        if (selectedState) {
            setCityLoading(true);
            const [fetchedCities, cityAuth] = await callAPI(`/cities/${selectedState}`, tokens);
            setCities(Array.isArray(fetchedCities) ? fetchedCities.map(city => ({ label: city.city_name, value: city.city_name })) : []);
            setCityLoading(false);
        } else {
            setCities([]);
        }
    };

    // Update state and propagate changes to parent
    const handleChange = async (event: { target: { name: any; value: any; }; }) => {
        const { name, value } = event.target;

        setLocalContactInfo({ ...localContactInfo, [name]: value });

        setErrors({ ...errors, [name]: '' });

        if (name === 'country') {
            await fetchEverything(value);
        } else if (name === 'state') {
            await fetchEverything(localContactInfo.country, value);
        }
        updateContactInformation({ ...localContactInfo, [name]: value });

    };

    return (
        <div className="p-2">
            <p className="about-me-header">Contact Information</p>
            <p className="about-me-description">
                Providing a job experience helps employers to understand that you are capable of doing the job. Use the form below to add your past job experiences.
            </p>
            <div className="container p-2 ">
                <div className="address-div">
                    <label htmlFor="" className="label-address">Please Provide Your Address <span className="text-danger">*</span></label>

                </div>
                {/* Country Selector */}
                <div className="container row flex-row">
                    <div className="d-flex">
                        <Form.Select name="country" value={localContactInfo.country} onChange={handleChange} className="mb-2 address-select">
                            <option value="" className="d-flex col-md-6 col-xs-12">Country</option>
                            {
                                countries.map((value: any, key: any) => {
                                    return <option key={key} >{value.country_name}</option>
                                })
                            }
                        </Form.Select>
                        {errors.country && <p>{errors.country}</p>}

                        {/* State Selector */}
                        <Form.Select className="mb-2 " name={"state"} value={localContactInfo.state} onChange={handleChange}  >
                            <option value="">{stateLoading ? "loading.." : "State"}</option>
                            {
                                states && states.length > 0 && states.map((state: any, key: any) => (
                                    <option key={key} value={state.state_name}>{state.state_name}</option>
                                ))
                            }
                        </Form.Select>

                    </div>

                    <div className="d-flex">
                        <Form.Select name="city" value={localContactInfo.city} onChange={handleChange} className="address-select">
                            <option value="">{cityLoading ? "Loading..." : "Select a City"}</option>
                            {Array.isArray(cities) && cities.length > 0 && cities.map((city, index) => (
                                <option key={index} value={city.value}>{city.label}</option>
                            ))}
                        </Form.Select>

                        <input
                            type="text"
                            name="streetAddress"
                            className="mt-2 input-address"
                            value={localContactInfo.streetAddress}
                            onChange={handleChange}
                            placeholder="Please Enter Street Address"
                        />
                    </div>
                    {errors.streetAddress && <p>{errors.streetAddress}</p>}

                </div>

            </div>
        </div>
    );
};

export const OnboardingModal = ({ children, closeModal, OtherActions, onClickTitle = 'Save', onClick, backdrop = "static", show = false, title = '', message, setMessage, data, ...rest }: any) => {

  return (
    <Modal
        onHide={closeModal}
        backdrop={backdrop}
        keyboard={false}
        show={show}
        size="xl"
        {...rest}
    >
        <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter" style={{ fontSize: "40px"}}>
                {title}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {children}
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
    </Modal>
  )
}